//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';

import { postRightsConfiguration } from '@apis/rights-management/rightsManagementApi';
import { toastNotificationsActions } from '@legacy-components/common/toast-notifications/toastNotificationsActions';
import { ALTERNATE_TOASTS } from '@legacy-components/common/toast-notifications/toastNotificationsConstants';
import { ToastType } from '@legacy-components/common/toast-notifications/toastNotificationsModel';
import { IRightsOption } from '@legacy-components/rights-management/request-rights-model';
import { QueryKeyConstants } from '@queries/QueryKeyConstants';

export const useRightsConfigurationsMutation = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (request: IRightsOption) => postRightsConfiguration(request),
    onSettled: async () => {
      await queryClient.invalidateQueries({
        queryKey: [
          QueryKeyConstants.UniversalImageActions,
          QueryKeyConstants.UniversalImageActionsRights,
          QueryKeyConstants.UniversalImageActionsRightsConfigurations,
        ],
      });
    },
    onError: () => {
      dispatch(
        toastNotificationsActions.addToastNotification({
          title: 'Something Went wrong',
          message: `An unexpected error occurred. Please try again or contact Bazaarvoice Support.`,
          type: ToastType.ERROR,
          options: {
            toastTemplate: ALTERNATE_TOASTS.NEW_TOAST,
          },
        }),
      );
    },
  });
};
